import { useMemo } from "react";
import { useAllocationRule } from "./mm-allocation-rule-provider";

/**
 * Warehouse ids covered by the current market's allocation rule, or undefined
 * while the rule is loading or unavailable. Undefined means "fall back to the
 * aggregate Centra stock" for consumers that filter stock by warehouse.
 */
export const useAllocatedWarehouseIds = (): string[] | undefined => {
  const { allocationRule } = useAllocationRule();

  return useMemo(() => {
    if (!allocationRule) {
      return undefined;
    }
    return allocationRule.warehouses.map((w) => String(w.id));
  }, [allocationRule]);
};
